import { Container, Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div style={{ marginTop: 100 }}>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <div>{children}</div>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};
